import RecentItems from './recent-items';
export default RecentItems;